export default __webpack_public_path__ + "static/media/banners_stall.9b237f01.png";